"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ClientMarkdownParsingComponent: ()=>ClientMarkdownParsingComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const external_chatTypes_js_namespaceObject = require("../../chatTypes.js");
const StreamingStatusContext_js_namespaceObject = require("../../context/StreamingStatusContext.js");
const useStreamingText_js_namespaceObject = require("../../hooks/useStreamingText.js");
const external_TravelBotLogoImage_js_namespaceObject = require("../../TravelBotLogoImage.js");
const MessageFooterWithVote_js_namespaceObject = require("../MessageFooter/MessageFooterWithVote.js");
const CitationsSources_js_namespaceObject = require("../MetadataMarker/CitationsSources.js");
const external_CustomMarkdown_js_namespaceObject = require("./CustomMarkdown.js");
const ClientMarkdownParsingComponent = (props)=>{
    const { finalTexts, webSearchResult, date, isMobile } = props;
    const isStreaming = (0, external_react_namespaceObject.useContext)(StreamingStatusContext_js_namespaceObject.StreamingStatusContext);
    const { settledText, streamingText } = (0, useStreamingText_js_namespaceObject.useStreamingText)(finalTexts, isStreaming);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
        mb: 4,
        variation: "initial",
        Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
        message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                settledText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CustomMarkdown_js_namespaceObject.CustomMarkdown, {
                    isStreaming: false,
                    children: settledText
                }),
                streamingText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CustomMarkdown_js_namespaceObject.CustomMarkdown, {
                    isStreaming: true,
                    children: streamingText
                }),
                !isStreaming && webSearchResult?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CitationsSources_js_namespaceObject.CitationsSources, {
                    citationsMeta: [],
                    webSearchResult: webSearchResult
                })
            ]
        }),
        footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooterWithVote_js_namespaceObject.MessageFooterWithVote, {
            footerMessagePrefix: "Penny",
            isNotUser: true,
            isGreetingMessage: false,
            isMobile: isMobile,
            message: {
                content: finalTexts,
                role: 'assistant',
                vote: external_chatTypes_js_namespaceObject.VoteType.NONE,
                date: date
            }
        })
    });
};
exports.ClientMarkdownParsingComponent = __webpack_exports__.ClientMarkdownParsingComponent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ClientMarkdownParsingComponent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
